export default __webpack_public_path__ + "static/GT-Walsheim-Regular-e7d96dc50b83e3d96f51640aa5de933a.woff";